import Modal from "../Modal/Modal";
import {
  Container,
  MainButton,
  Row,
  RowContainer,
} from "./SessionExpiredModalStyles";

function SessionExpiredModal(props) {
  const { onClickRefresh } = props;

  return (
    <Modal>
      <Container>
        <h1>Sesión Expirada</h1>
        <RowContainer>
          <Row>
            <h2>
              Su sesión ha expirado. Haga clic en Refrescar para iniciar sesión
              nuevamente.
            </h2>
          </Row>
        </RowContainer>
        <MainButton onClick={onClickRefresh}>Refrescar</MainButton>
      </Container>
    </Modal>
  );
}

export default SessionExpiredModal;
